import { useNavigate } from 'react-router-dom';
import { useEffect } from 'react';

const AdminLogout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    localStorage.removeItem('access');
    localStorage.removeItem('refresh');
    navigate('/login'); // Redirect to login page after logout
    window.location.reload(); // Force a refresh to update the layout
  }, [navigate]);

  return <div>Logging out...</div>;
};

export default AdminLogout;

